import services from './services';
import {
  lg,
  cloneDeep,
  util,
} from 'utils';

import NProgress from 'nprogress';
import OrderInfo from './components/orderDetails/index.vue'; //下单信息组件
import validate from 'validate';

export default {
  mixins: [services],
  components: {
    OrderInfo,
  },
  data() {
    return {
      form: this.getFormData(),
      loading: false,
      ModifyData: this.getModifyData(),
      dialogVisible: false,
      orderTypes: [{
        id: 2,
        name: '普通'
      }, {
        id: 3,
        name: '转介绍'
      }, {
        id: 4,
        name: '团购'
      }],
      groups: [{
        id: 2,
        name: '2人团'
      }, {
        id: 3,
        name: '3人团'
      }, {
        id: 4,
        name: '4人团'
      }, {
        id: 5,
        name: '5人团'
      }, {
        id: 6,
        name: '6人团'
      }, {
        id: 7,
        name: '7人团'
      }, {
        id: 8,
        name: '8人团'
      }, {
        id: 9,
        name: '9人团'
      }, {
        id: 10,
        name: '10人团'
      }],
      orderNum: [{
        flag: false,
        orderInfoData: this.orderInfoData
      }],
      currentOrderNum: 1,
      isReadOnly: false,
      orderInfoData: null, //存储下单信息
      RefereeInfoData: null, //存储转介绍人信息

    }
  },
  methods: {
    getFormData() {
      return cloneDeep({
        OrderSource: "",
        GroupPeopleNum: '',
        RefereeBabyId: 0,
        RefereeParentId: 0,
        ListBaby: [],
        PackageId: 10002, //默认联帮在家ABC

      });
    },
    getModifyData() {
      return cloneDeep({
        "OrderId": 0,
        "NetInfo": {
          "NetworkOperator": [
            0
          ],
          "NetworkType": [
            0
          ],
          "Distance": 0,
          "Engineer": 0
        },
        "ReceiptInfo": {
          "ConsigneeId": 0
        },
        "PayList": [{
          "PayWay": 0,
          "Trade_No": "",
          "BankName": "",
          "VoucherPic": "",
          "OrderActualPrice": 0,
          "PayRemark": ""
        }]
      })
    },
    handleCurrentChange() {
      this.orderInfoData = null
      this.RefereeInfoData = null
      this.dialogVisible = false
      this.isReadOnly = false
      this.form = this.getFormData() //初始化数据
      this.$nextTick(() => {
        this.orderNum = [{
          flag: false,
          orderInfoData: this.orderInfoData
        }]
      })
      console.log(this.orderNum)
      this.currentOrderNum = 1
      this.ModifyData = this.getModifyData()
      for (let i = 0; i < this.orderNum.length; i++) {
        this.$refs['OrderInfo' + (i + 1)][0].initData()
      }

    },
    // 切换套餐
    changePackage(val){
      if(val==10003){
        this.form.OrderSource=2
        this.form.GroupPeopleNum = ''
      }else{
        this.form.OrderSource=''
      }
    },
    // 选择订单类别
    changeOrderSource(val) {
      if (!this.isReadOnly) {
        this.form.GroupPeopleNum = ''
      }

      this.currentOrderNum = 1
      if (val !== '') {
        this.orderNum = []
      }
      if (val == 3) {
        this.orderNum = [{
          flag: true,
          orderInfoData: this.RefereeInfoData
        }, {
          flag: false,
          orderInfoData: this.orderInfoData
        }]
        this.$nextTick(() => {
          for (let i = 0; i < this.orderNum.length; i++) {

            this.$refs['OrderInfo' + (i + 1)][0].initData()
          }
        })

      } else if (val == 2) {
        this.orderNum.push({
          flag: false,
          orderInfoData: this.orderInfoData
        })
        this.$nextTick(() => {
          for (let i = 0; i < this.orderNum.length; i++) {

            this.$refs['OrderInfo' + (i + 1)][0].initData()
          }
        })
      } else if (val == 4 && this.isReadOnly) {
        this.orderNum.push({
          flag: false,
          orderInfoData: this.orderInfoData
        })
      }
    },
    // 选择团购人数
    changeGroups(num) {

      this.orderNum = []
      this.currentOrderNum = 1
      if (this.form.OrderSource == 3) {
        // 转介绍
        this.orderNum.push({
          flag: true,
          orderInfoData: this.RefereeInfoData
        }, {
          flag: false,
          orderInfoData: this.orderInfoData
        })

      } else if (this.form.OrderSource == 2) {
        // 普通
        this.orderNum.push({
          flag: false,
          orderInfoData: this.orderInfoData
        })
      } else {
        //团购
        if (num !== '') {
          if (this.isReadOnly) {

            // 团购单条修改
            this.orderNum.push({
              flag: false,
              orderInfoData: this.orderInfoData
            })
          } else {
            for (let i = 1; i <= num; i++) {
              this.orderNum.push({
                flag: false,
                orderInfoData: this.orderInfoData
              })
            }
          }

        }
      }

    },
    // 继续下单或关闭弹窗
    handleClose() {
      this.dialogVisible = false
      this.$nextTick(() => {
        this.handleCurrentChange()
      })
    },
    goToList() {
      this.$router.push("/Family/OrderList");
    },
    // 提交
    submit() {
      let checkRules = [{
        name: "订单类型",
        value: this.form.OrderSource,
        required: this.PackageId == 10002 ? true : false,
        msg: "请选择订单类型"
      }];



      if (this.form.OrderSource == 4) {
        // 团购
        checkRules.push({
          name: "团购人数",
          value: this.form.GroupPeopleNum,
          required: true,
          msg: "请选择团购人数"
        })
      }


      var flag = util.checkForm({
        ele: this,
        rules: checkRules
      });
      if (!flag) {
        return;
      }
      this.form.ListBaby = []
      for (let i = 0; i < this.orderNum.length; i++) {
        let dataInfo = this.$refs['OrderInfo' + (i + 1)][0].validate();
        console.log(dataInfo)
        if (dataInfo) {
          if (this.orderNum[i].flag && !this.isReadOnly) {
            // 转介绍
            if (dataInfo.RefereeBabyId <= 0) {
              this.$notify({
                title: '警告',
                message: '请选择转介绍宝贝',
                type: 'warning'
              });
              return;
            }
            this.form.RefereeBabyId = dataInfo.RefereeBabyId
            this.form.RefereeParentId = dataInfo.RefereeParentId
          } else {
            // this.form.RefereeBabyId = 0
            // this.form.RefereeParentId = 0
            if (this.ModifyData.OrderId == 0) {
              this.form.ListBaby.push(dataInfo);
            } else {
              // 修改
              this.ModifyData = cloneDeep($.extend({}, this.getModifyData(), dataInfo));
              this.ModifyData.OrderId = cloneDeep(this.$route.query.OrderId)

            }
          }
        } else {
          return;
        }
      }
      console.log(this.form)
      if (this.ModifyData.OrderId == 0) {
        this.getAddOrderList()
      } else {
        this.UserOrderModify()
      }



    }
  },
  created() {

  },
  computed: {
    tableData() {
      let num = '--'
      let title = '赠课'
      if (this.form.OrderSource == 4 && this.form.GroupPeopleNum > 0) {
        // 团购
        title = '赠课'
        if (this.form.GroupPeopleNum < 4) {
          // 2 3
          num = 6
        } else if (3 < this.form.GroupPeopleNum && this.form.GroupPeopleNum < 6) {
          // 4 5
          num = 8
        } else {
          // 6 7 8 9 10
          num = 10

        }
      } else if (this.form.OrderSource == 3) {
        // 转介绍
        title = '介绍人赠课'
        num = 6
      }
      let Arr = [{
        Type: "实物",
        Details: [{
          option1: '家庭在线教室终端',
          num: 1,
          remark: "财务审核通过后安排发货"
        }, {
          option1: '艺术盒子（4套组合）',
          num: 1,
          remark: "待体验课评级后发货"
        }, {
          option1: '教材（包含习作本）',
          num: 1,
          remark: "待体验课评级后发货"
        }]
      }, {
        Type: "课程",
        Details: [{
          option1: '入门测评课',
          num: 5,
          remark: "1节双语课程指导+4节外教课"
        }, {
          option1: '正式课',
          num: 65,
          remark: "48节外教课+16节双语老师学习指导+1节亲子艺术大师指导"
        }, {
          option1: title,
          num: num,
          remark: "---"
        }]
      }]
      let Arr2 = [{
        Type: "实物",
        Details: [{
          option1: '家庭在线教室终端',
          num: 1,
          remark: "财务审核通过后安排发货"
        }, {
          option1: '艺术盒子（4套组合）',
          num: 1,
          remark: "待体验课评级后发货"
        }, {
          option1: '教材（包含习作本）',
          num: 1,
          remark: "待体验课评级后发货"
        }]
      }, {
        Type: "课程",
        Details: [{
          option1: '入门测评课',
          num: 5,
          remark: "1节双语课程指导+4节外教课"
        }, {
          option1: '正式课',
          num: 65,
          remark: "48节外教课+16节双语老师学习指导+1节亲子艺术大师指导"
        }]
      }]
      let Arr3 = [{
        Type: "实物",
        Details: [{
          option1: '艺术盒子（4套组合）',
          num: 1,
          remark: "财务审核通过后安排发货"
        }, {
          option1: '教材（包含习作本）',
          num: 1,
          remark: "待体验课评级后发货对应评级教材"
        }]
      }, {
        Type: "课程",
        Details: [{
          option1: '正式课',
          num: 65,
          remark: "48节外教课+16节双语老师学习指导+1节亲子艺术大师指导"
        }]
      }]
      if (this.form.PackageId == 10002) {
        if (this.form.OrderSource == 2) {
          // 普通
          return Arr2
        } else {
          return Arr
        }
      } else {
        // 续费套餐
        return Arr3
      }


    }
  },
  created() {
    //console.log(this.$route.query)

    if (this.$route.query.isReadOnly) {
      this.isReadOnly = this.$route.query.isReadOnly
      this.ModifyData.OrderId = this.$route.query.OrderId
      this.getById(this.ModifyData.OrderId)
    } else {
      this.$nextTick(() => {
        this.handleCurrentChange()
      })
      this.isReadOnly = false
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/Order/LBHomeOrder/vm.js